import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import KidsPartyContentSection from './components/KidsPartyContentSection';
import KidsPartyReservationSection from './components/KidsPartyReservationSection';

export default function EventsChildrenPage() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <KidsPartyContentSection />
        <KidsPartyReservationSection />
      </main>
      <Footer />
    </div>
  );
}